import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CompanyData, CompanyService } from '../services/company.service';
import { Subscription } from 'rxjs';
import { Pdf } from '../coms';
import { PdfTemplates } from '../pdfTemplates';
import { HttpClient } from '@angular/common/http';
import { DevDatabase } from '../../dev/devDatabase.class';
import { FirestoreService } from '../services/firestore/firestore.service';
import { CustomerBillId } from '../services/customer-bill.service';
import { Globals } from '../globals';
import { Utils } from '../util';
import { EmployeeId } from '../services/employee.service';
import { ExpenseConcept } from '../services/expense-concept.service';
import { FiscalDataId } from '../services/fiscal-data.service';
import { PostalCodeCatalog } from '../../catalogs/postalCode';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {    
    company: any = {};
    sub: Subscription;

    constructor(
        private service: CompanyService,
        private authService: AuthService,
        private firestoreService: FirestoreService,
        private router: Router,
        private companyData: CompanyData,
       
        private http: HttpClient,
    ) {
        //window['tmpPrClientsFn'] = () => this.tmp_getAllPrClients();
        /* let url = 'https://interfaces.medicospro.com/facturacion/ILU120330MG3/Cfdi/Factura_A_4_Timbrado.txt';
        this.http.get(url).subscribe(r => {
            console.log(
                r
            )
        }) */

        //window['tmp_exportFiscalDatas'] = () => this.exportFiscalDatasToExcel();

        this.loadExternalInterface();
        PostalCodeCatalog.initializeCatalog();
        //console.log(this.authService.currentUser);
        //if(!this.authService.currentUser) this.router.navigate(['/login']);
        
        /* console.table(defs.map(({customerId, ...def}: Defect) => {
            let o: Defect = {
                customerId: isNaN(+customerId) ? 'E7AF5fgxIeL5AdTzCnPR' : '',
                ...def
            }
            this.defectService.addDefect(o);
        } )); */
    }

    ngOnInit() {
        console.log('init home');
        this.sub = this.service.getCompany().subscribe(company => {
            console.log(`got company: `, company);
            this.sub.unsubscribe();
            this.company = company;
        }, error => console.log(error));
    }

    loadExternalInterface(){
        console.log('loaded external');
        window['sendPurchaseOrderToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendProductionOrderToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendProductionOrderToPhpIlusa'] = function (sendEmail){
            document.getElementById("email_form_ilusa")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_ilusa")['submit']();
        }
        window['sendProductionOrderComprasToPhp'] = function (sendEmail){
            document.getElementById("email_form_alt")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_alt")['submit']();
        }
        window['sendPrClientToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendPrClientEspecificacionToPhp'] = function (sendEmail){
            document.getElementById("email_form_alt")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_alt")['submit']();
        }
        window['sendRemissionToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendRemissionEtiquetasToPhp'] = function (sendEmail){
            document.getElementById("email_form_alt")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_alt")['submit']();
        }
        window['sendRemissionTimbradoToPhp'] = function (sendEmail){
            document.getElementById("email_form_alt2")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_alt2")['submit']();
        }
        window['sendQualityCertificate'] = function (sendEmail){
            document.getElementById("email_form_alt2")['sendEmail'].value = sendEmail ? 'true' : 'false';
            document.getElementById("email_form_alt2")['submit']();
        }
        window['sendFacturaToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendFacturaToEmail'] = function (json){
            document.getElementById("email_form_email")['data'].value = json;
            document.getElementById("email_form_email")['sendEmail'].value = `true`;
            document.getElementById("email_form_email")['submit']();
        }
        window['sendCancelacionFacturaToPhp'] = function (sendEmail){
            document.getElementById("email_form_alt")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form_alt")['submit']();
        }
        window['sendNotaCreditoToPhp'] = function (json){
            document.getElementById("email_form_nc")['data'].value = json;
            document.getElementById("email_form_nc")['sendEmail'].value = `false`;
            document.getElementById("email_form_nc")['submit']();
        }
        window['sendNotaCreditoCancelToPhp'] = function (json){
            document.getElementById("email_form_ncc")['data'].value = json;
            document.getElementById("email_form_ncc")['sendEmail'].value = `false`;
            document.getElementById("email_form_ncc")['submit']();
        }
        window['sendIncToPhp'] = function (json){
            document.getElementById("email_form_com")['data'].value = json;
            document.getElementById("email_form_com")['sendEmail'].value = `false`;
            document.getElementById("email_form_com")['submit']();
        }
        window['sendQuotationToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendIncomeToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']();
        }
        window['sendCredentialToPhp'] = function (sendEmail){
            document.getElementById("email_form")['sendEmail'].value = sendEmail ? 'true' : 'false';
            document.getElementById("email_form")['submit']();
        }
        window['sendSuajeToPhp'] = function (sendEmail){
            console.log();
            document.getElementById("email_form")['sendEmail'].value = `${!!sendEmail}`;
            document.getElementById("email_form")['submit']()
        }
        //console.log(window['sendFacturaToPhp'])
    }

    async backupCols(){
        let cols: {name: string, title: string}[] = [
            {name: Globals.EMPLOYEE_COLLECTION, title: 'Empleados'},
        ];
        for(let col of cols){
            console.log(`Doing col '${col.name}', '${col.title}'.`);
            let docs: EmployeeId[] = await this.firestoreService.colWithIds<EmployeeId>(col.name);
            let rows: string[][] = [];
            docs.map((doc, index) => {
                let keys: string[] = Object.keys(doc);
                if(!index) rows.push([...keys]);
                let row: string[] = [];
                for(let key of keys) row.push(`${doc[key].toString()}`);
                rows.push(row);
            });
            console.log(rows);
            
            if(!confirm(`Download excel for col '${col.name}', '${col.title}'?`)) continue;
            Utils.downloadExcel(rows, 'EmpleadosAgroviva2021');
        }
    }
    
    async tmp_getColJson(){
        let cons = await this.firestoreService.colWithIds<ExpenseConcept>(Globals.EXPENSE_CATEGORY_COLLECTION);
        /* for(let con of cons){
            delete con.id;
            let ref = con.expenseCategoryRef.path;
            delete con.expenseCategoryRef;
            con['ref'] = ref;
        } */
        console.log(JSON.stringify(cons));
    }
    async tmp_setColFromJson(){
        //let json = `[{"active":true,"name":"BVQI Mexicana,S.A. de C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Aguinaldo ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Comisiones bancarias","ref":"expenseCategory/F0L4jgI4IaqT9BwTHhWs"},{"active":true,"name":"Fletes y mensajeria","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Gastos No deducibles ","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Soluciones Integrales de mercadotecnia","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Pago de préstamos bancarios","ref":"expenseCategory/F0L4jgI4IaqT9BwTHhWs"},{"active":true,"name":"Cuotas IMSS","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Hernández Bautista Miguel Angel","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Empaque de rollo","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Etiquetas","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Gasolina ","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Infonavit ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Despensa y Art. de aseo para oficinas (café soluble, azúcar, fibras, walmart, abasto básico) ","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Prima Vacacional ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"tiempo extra","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Sueldos ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Fumigaciones ","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Vacaciones ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Herrera Gómez David ","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Vacaciones ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"RCV ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Cajas de empaque","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Recolección de desechos","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Factual Services,S.C.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Castro Andriano Elvira","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Gastos admin. Dirección ","ref":"expenseCategory/UcwxGeQs4Q9EFPxDYspE"},{"active":true,"name":"Placas","ref":"expenseCategory/L6auGel7Gi7LtRAIwmvy"},{"active":true,"name":"Seguros y fianzas(persona moral y persona física)","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Solventes y Soluciones Concentradas","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"DMB Abogados y asesores de negocios ","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Semper paratus consultores,S.A de C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Suministro de Agua ","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Compulan Security,S.A. de C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Infonavit ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"3 % sobre Nómina ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Uniformes/ botas / guantes / fajas./ Cofias etc","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Gastos de Dirección","ref":"expenseCategory/UcwxGeQs4Q9EFPxDYspE"},{"active":true,"name":"Aguinaldo ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Recargos y Actualizaciones Fiscales","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Sánchez Maldonado Consultores y Asociados,S.C.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Triana Seguridad Privada,S.A. de C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Estrada Hernández Berenice Lisete","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Negativos","ref":"expenseCategory/xAhtlLFWZ66hE973PEix"},{"active":true,"name":"Maquila(pegado,corte, suaje de caja, laminado,estampado, realce de caja)","ref":"expenseCategory/1PI2OCg3h5awAbU7tILK"},{"active":true,"name":"Diesel","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Prima Vacacional ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Gastos de Viaje (Hospedaje y Alimentos,casetas)","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Energía Eléctrica","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Químicos (alcohol isopropilico,thiner, petróleo)","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"RCV ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Tintas/Barniz","ref":"expenseCategory/xAhtlLFWZ66hE973PEix"},{"active":true,"name":"Sueldos ","ref":"expenseCategory/Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Cañas e Hijos Consultores,S.A DE C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Agua (garrafones)","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"otras deducciones","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Herramientas, Refacciones y Accesorios","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Cuotas IMSS","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Mantto. De transporte y Eq. De cómputo (paqueteria aspel, impresoras, mantto. Oficinas,)","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Verificación, tenencia, refrendo (camión y vehículos) Y Otros impuestos y derechos ","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Material para Empaque ","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Papelería y art.de oficina(Impresión de ploter)","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"otras prestaciones","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Positivos","ref":"expenseCategory/L6auGel7Gi7LtRAIwmvy"},{"active":true,"name":"Capacitación al personal","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Cartón ","ref":"expenseCategory/xAhtlLFWZ66hE973PEix"},{"active":true,"name":"Blanco Torres Salvador","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Botiquín","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Pegamentos y Goma( migtor, kola loca,placas)","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Impuesto Predial ","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"3 % sobre Nómina ","ref":"expenseCategory/SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Mtto. de Maquinaria, Elevador y Montacargas (toda refacción)","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Reemplacado","ref":"expenseCategory/L6auGel7Gi7LtRAIwmvy"},{"active":true,"name":"Comidas Deducibles  ","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Wingu Networks, S.A. DE C.V.","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Saavedra Kuri Elsa Martha","ref":"expenseCategory/pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Teléfono, Servicio celular, Internet","ref":"expenseCategory/KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Pasajes y trasporte (Cabify)","ref":"expenseCategory/KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Cinta transparente","ref":"expenseCategory/hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Factoraje, notas de cargo y descuentos a Clientes","ref":"expenseCategory/F0L4jgI4IaqT9BwTHhWs"}]`;
        let json = `[{"active":true,"name":"Costo Directo Maquila","shortName":"Cto Dir","id":"1PI2OCg3h5awAbU7tILK"},{"active":true,"name":"MdO Producción","shortName":"MO Prod","id":"Cpqsr66V4M51GnvTI3b9"},{"active":true,"name":"Gastos financieros","shortName":"Finan","id":"F0L4jgI4IaqT9BwTHhWs"},{"active":true,"name":"Otros gastos","shortName":"Otro","id":"KVOtRwu8Ky5HabnUhDCM"},{"active":true,"name":"Servicios","shortName":"Serv","id":"KxhmFVQVcvgh6Fum3Uug"},{"active":true,"name":"Costo Directo Preprensa","shortName":"Cto Dir","id":"L6auGel7Gi7LtRAIwmvy"},{"active":true,"name":"MdO Indirecto","shortName":"MO Ind","id":"SdnMFyTlhLUvV5OrsbdM"},{"active":true,"name":"Gastos de dirección","shortName":"Direc","id":"UcwxGeQs4Q9EFPxDYspE"},{"active":true,"name":"Indirectos Producción","shortName":"CI Prod","id":"hjgKVMEWabP7HgBt5N8W"},{"active":true,"name":"Gastos de administración","shortName":"Admin","id":"pbpxPf2T39yUv6Mgnb1m"},{"active":true,"name":"Costo Directo Impresión","shortName":"Cto Dir","id":"xAhtlLFWZ66hE973PEix"}]`;
        let docs = JSON.parse(json);
        for(let doc of docs){
            //doc.expenseCategoryRef = this.firestoreService.doc(doc.ref).ref;
            //delete doc.ref;
            await this.firestoreService.set(`${Globals.EXPENSE_CATEGORY_COLLECTION}/${doc.id}`, doc);
            console.log('Added.');
        }
    }

    /* async tmp_getAllPrClients(){
        //let acts = await this.firestoreService.colWithIds('activity');
        //for(let act of acts) console.log(act.id, act.name);
        let docs = await this.firestoreService.colWithIds('production_order');
        window['prClientsAll'] = docs;
        let prClientCount = 0;
        let prClientNotCount = 0;
        let activityCount = 0;
        for(let doc of docs){
            let docHas = false;
            let docCount = 0;
            for(let sec of doc.sections){
                for(let act of sec.activities) if(!act.actId){
                    docHas = true;
                    activityCount++;
                    docCount++;
                }
            }
            if(docHas){
                prClientCount++;
                console.log(`PR.${doc.id}`, docCount)
                let i = 0;
                for(let sec of doc.sections) for(let act of sec.activities){
                    if(!act.actId) console.log(`** '${i}' ${act.name}`);
                    i++;
                }
            }
            else prClientNotCount++;
            console.log('.');
        }
        console.log(prClientNotCount, prClientCount, activityCount)
    } */

    /* 
    devFunction: () => void = window['devFunction'] = () => {
        let devDatabase = new DevDatabase(this.firestoreService);
        devDatabase.setField<CustomerBillId, 'receptionDate'>(
            Globals.CUSTOMER_BILL_COLLECTION,
            'receptionDate',
            bill => bill.date,
            [
                {field: 'active', opt: '==', value: true},
            ],
        ).then(() => console.log('999')).catch(e => console.log('666', e));
    }
    */

    async exportFiscalDatasToExcel(){
        let fiscalDatas = await this.firestoreService.colWithIds<FiscalDataId>(Globals.FISCAL_DATA_COLLECTION, ref => ref.where('active', '==', true).where('supplierId', '==', ''));
        console.log(`Got ${fiscalDatas.length} fiscalDatas.`);
        let headers: string[] = ['Id', 'Razón social', 'RFC', 'Código postal', 'Régimen fiscal'];
        let rows: string[][] = fiscalDatas.map(fiscalData => [
            fiscalData.id,
            fiscalData.businessName || '',
            fiscalData.rfc || '',
            Utils.Object.keys(PostalCodeCatalog.obj).includes(fiscalData.postCode) ? fiscalData.postCode : '',
            (this.companyData.fiscalRegimenSelect[fiscalData.fiscalRegimen] || {code: ''}).code,
        ]);
        Utils.downloadExcel([headers, ...rows], 'razonesSociales');
    }

    async colToJson(colPath: string = prompt('Collection: '), subColPath = prompt('Sub collection: ', 'employees')){
        if(!colPath) return alert('No col.');
        let devDatabase = new DevDatabase(this.firestoreService);
        await devDatabase.exportColToJson(colPath, { subColPath });
    }

    async archiveOdps(){
        console.log(`Starting archiveOdps.`);
        let devDatabase = new DevDatabase(this.firestoreService);
        await devDatabase.archiveOdpsToDifferentCollection();
        console.log(`Finished archiveOdps.`);
    }

}
